export default "__VITE_ASSET__BZXXrYWD__"